import { Component } from '@angular/core';
import { ChatService } from '../chat.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'bidi-channel-list',
  templateUrl: './channel-list.component.html',
  styleUrls: ['./channel-list.component.scss']
})
export class ChannelListComponent {
  selectedChannelJid$: Observable<string> = this.chatService.selectedChannel$.pipe(
    map(channel => channel && channel.jid)
  );

  constructor (public chatService: ChatService) {
  }

  back () {
    this.chatService.selectGroup(null);
    this.chatService.selectChannel(null);
  }
}
